export default "__VITE_PUBLIC_ASSET__782951ac__"